import baseStyles from '../Base/Base.styles'
import { parseResponsiveProperty } from '@converdy/styles'
import SwipeableGridStyles from '../SwipeableGrid/SwipeableGrid.styles'

export default ({
  base,
  backgroundColor,
  iconColor,
  dividerColor,
  descriptionColor,
  authorNameColor,
  authorJobColor,
  columns,
  swipeableGrid
}) => {
  return {
    root: {
      ...baseStyles(base),
      '--item-background-color': backgroundColor,
      '--item-icon-color': iconColor,
      '--item-divider-color': dividerColor,
      '--item-description-color': descriptionColor,
      '--item-author-name-color': authorNameColor,
      '--item-author-job-color': authorJobColor,
      '& .grid-wrapper': SwipeableGridStyles(swipeableGrid)
    }
  }
}
